var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightSuggest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#647A97",
    d: "M20.923 8.66c-1.173.394-13.106 4.221-13.106 4.221s-3.303 1.226-5.748-2.079l2.713-1.25c.471.178.91.163 1.493-.045l3.084-.847-4.626-7.594S3.795-.584 7.045.22c0 0 5.878 4.99 6.938 5.907 0 0 .542.342 1.542 0l4.626-1.689s3.133-1.06 3.853.845c.76 1.997-1.91 2.983-3.081 3.376zm-19.42.995C.242 8.361 0 7.6 0 7.6s.26-1.583 2.416 0c.629.462 1.297.78 1.722 1.04L1.504 9.654z"
  })));
}
export default SvgFlightSuggest;